// src/components/Camera/GatewayCameraGrid.js
// Componente para mostrar una cuadrícula de cámaras conectadas a un gateway de medios
// basado en el software de xhuvom https://github.com/xhuvom/WebRTC_RTSP_Video_Streaming_Server_Client#

import React, { useState, useEffect } from 'react';
import { io } from 'socket.io-client';
import GatewayCameraViewer from './GatewayCameraViewer';
import './camera.css';

const GatewayCameraGrid = ({ gatewayUrl = 'http://localhost:8080' }) => {
  const [socket, setSocket] = useState(null);
  const [cameras, setCameras] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState(null);
  const selectedQuality = 'medium';
  
  useEffect(() => {
    // Initialize socket connection to gateway
    const newSocket = io(gatewayUrl, {
      path: '/ws/',
      transports: ['websocket', 'polling'],
      auth: {
        token: localStorage.getItem("token") // o donde guardes el token
      }
    });

    newSocket.on('connect', () => {
      console.log('🔗 Connected to media gateway');
      setIsConnected(true);
      setError(null);
      
      // Request camera list
      newSocket.emit('get-cameras');
    });

    newSocket.on('disconnect', () => {
      console.log('❌ Disconnected from media gateway');
      setIsConnected(false);
    });

    newSocket.on('connect_error', (err) => {
      console.error('Connection error:', err);
      setError(`Failed to connect to gateway: ${err.message}`);
      setIsConnected(false);
    });

    newSocket.on('cameras-list', (data) => {
      console.log('📹 Received camera list:', data);
      setCameras(data.cameras || []);
    });

    newSocket.on('camera-frame', (data) => {
      // Frames will be handled by individual camera components
      // This is just for debugging
      // console.log(`📥 Frame from camera ${data.cameraId}: ${data.frame.length} chars`);
    });

    newSocket.on('camera-started', (data) => {
      console.log(`✅ Camera ${data.cameraId} started streaming`);
      updateCameraStatus(data.cameraId, 'streaming');
    });

    newSocket.on('camera-stopped', (data) => {
      console.log(`🛑 Camera ${data.cameraId} stopped streaming`);
      updateCameraStatus(data.cameraId, 'inactive');
    });

    newSocket.on('camera-error', (data) => {
      console.error(`❌ Camera ${data.cameraId} error:`, data.error);
      updateCameraStatus(data.cameraId, 'error');
    });

    setSocket(newSocket);

    // Cleanup on unmount
    return () => {
      newSocket.close();
    };
  }, [gatewayUrl]);

  const updateCameraStatus = (cameraId, status) => {
    setCameras(prevCameras => 
      prevCameras.map(camera => 
        camera.id === cameraId 
          ? { ...camera, status }
          : camera
      )
    );
  };



  return (
    <div className="gateway-camera-grid">
      

      
      {/* Error Display */}
      {error && (
        <div className="error-message gateway-error">
          {error}
        </div>
      )}

      {/* Camera Grid */}
      {isConnected ? (
        <div className="camera-grid">
          {cameras.length > 0 ? (
            cameras.map((camera) => (
              <GatewayCameraViewer
                key={camera.id}
                camera={camera}
                socket={socket}
                defaultQuality={selectedQuality}
              />
            ))
          ) : (
            <div className="no-cameras">
              <div style={{ fontSize: '3rem', marginBottom: '20px' }}>📹</div>
              <h3>No cameras configured</h3>
              <p>Update the camera configuration in the gateway server.</p>
            </div>
          )}
        </div>
      ) : (
        <div className="connection-waiting">
          <div className="loading">
            <div className="spinner"></div>
            <span>Connecting to media gateway...</span>
          </div>
          <p style={{ marginTop: '15px', color: '#666' }}>
            Make sure the gateway server is running on {gatewayUrl}
          </p>
        </div>
      )}

    </div>
  );
};

export default GatewayCameraGrid; 